import { CSSProperties } from 'react';
import colors from '../../../../../utils/colors';

export default {
    container: {
        position: 'relative',
        backgroundColor: colors.cardBackground,
        borderRadius: 8,
        marginTop: 20,
        marginBottom: 20,
        padding: 20
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    button: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        color: colors.title
    },
    driverName: {
        fontSize: 20,
        color: colors.title,
        fontWeight: 'bold'
    },
    callButton: {
        borderRadius: 20,
        backgroundColor: 'white',
        paddingTop: 12,
        paddingBottom: 12,
        paddingLeft: 16,
        paddingRight: 16,
        marginLeft: 8,
        boxShadow: `0 4px 8px ${colors.shadow}`,
        cursor: 'pointer',
        fontSize: 14,
        fontWeight: 'bold',
        cursor: 'pointer'
    },
    callIcon: {
        marginRight: 8,
        transform: 'rotateY(180deg)'
    },
    lineDivider: {
        width: '100%',
        height: 0.5,
        backgroundColor: '#aaa',
        marginTop: 16,
        marginBottom: 8
    },
    infoText: {
        fontSize: 12,
        color: colors.info
    }
} as Record<string, CSSProperties>;
